import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-feature-discovery',
    templateUrl: './feature-discovery.component.html',
    styleUrls: ['./feature-discovery.component.scss'],
    standalone: false,
})
export class FeatureDiscoveryComponent {
    @Input() featureFlagKey: string;
    /* eslint-disable-next-line @typescript-eslint/no-explicit-any */
    @Input() customTarget: any;
}
